// extracted by mini-css-extract-plugin
module.exports = {"main":"HomeTemplate_main__M4BJk","title":"HomeTemplate_title__915Me","quarter":"HomeTemplate_quarter__ZzICG","rotation":"HomeTemplate_rotation__66Vq_"};